import axios from 'axios';
import conf from '@/util/conf';
import store from '@/store';
import router from '@/router';

const instance = axios.create({
  baseURL: conf.value('VUE_APP_BASE_API_URL'),
  headers: { 'Content-Type': 'application/json' }
});

instance.interceptors.request.use((config) => {
    const token = store.getters['auth/token'];
    if (token) {
      config.headers.Authorization = `Bearer ${ token }`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use((res) => res,
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig.url !== '/auth' && err.response) {
      // access token was expired
      let statusForbidden = [403, 401];
      if (statusForbidden.includes(err.response.status)) {
        if (!originalConfig._retry) {
          originalConfig._retry = true;
          try {
            return instance(originalConfig);
          } catch (error) {
            await store.dispatch('auth/logout');
            router.push('/login');
            return Promise.reject(error);
          }
        } else {
          await store.dispatch('auth/logout');
          router.push('/login');
          return Promise.reject(err.response.status);
        }
      }
    }
    return Promise.reject(err);
  }
);

export default instance;
